import configuration from './../config.json'
import reportService from '../shared/services/reportService'
import CookieService from './../shared/services/cookiesService'
import { setLogout } from './authActions'

const REQUEST_SAVE_UNIT_REPORT = 'REQUEST_SAVE_UNIT_REPORT'
const RESPONSE_SAVE_UNIT_REPORT = 'RESPONSE_SAVE_UNIT_REPORT'
const REQUEST_SAVE_UNIT_REPORT_FAILURE = 'REQUEST_SAVE_UNIT_REPORT_FAILURE'
const CLEAR_SAVE_UNIT_REPORT = 'CLEAR_SAVE_UNIT_REPORT'

const requestSaveUnitReportAction = () => {
  return {
    type: REQUEST_SAVE_UNIT_REPORT
  }
}

const responseSaveUnitReportAction = () => {
  return {
    type: RESPONSE_SAVE_UNIT_REPORT
  }
}

const requestSaveUnitReportFailureAction = errors => {
  return {
    type: REQUEST_SAVE_UNIT_REPORT_FAILURE,
    errors
  }
}

const saveUnitReport = (id, options) => {
  return (dispatch) => {
    dispatch(requestSaveUnitReportAction())

    reportService.saveReport(id, options)
      .then((result) => {
        CookieService.updateExpires(configuration.cookieName, 12)

        dispatch(responseSaveUnitReportAction())
      })
      .catch((error) => {
        dispatch(requestSaveUnitReportFailureAction(error.response))

        if (error.response && error.response.status === 401) {
          dispatch(setLogout())
        }
      })
  }
}

const clearSaveUnitReportAction = () => {
  return {
    type: CLEAR_SAVE_UNIT_REPORT
  }
}

const clearSaveUnitReport = () => {
  return (dispatch) => {
    dispatch(clearSaveUnitReportAction())
  }
}

export {
  saveUnitReport,
  requestSaveUnitReportAction,
  responseSaveUnitReportAction,
  requestSaveUnitReportFailureAction,
  clearSaveUnitReport,
  clearSaveUnitReportAction,
  REQUEST_SAVE_UNIT_REPORT,
  RESPONSE_SAVE_UNIT_REPORT,
  REQUEST_SAVE_UNIT_REPORT_FAILURE,
  CLEAR_SAVE_UNIT_REPORT
}